function updateURLParams(updatedTagsObj) {
    let params = [];
    for (let category in updatedTagsObj){
        let tagsArr = updatedTagsObj[category];
        
        for(let obj of tagsArr){
            let tag = obj.name;
            if (tag !== "") {
                params.push(tag); 
            }
        }
    }

    return params;
}

export {
    updateURLParams
}      
